var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-panel',{scopedSlots:_vm._u([{key:"head",fn:function(){return [_c('h1',[_vm._v("H-index")])]},proxy:true},{key:"body",fn:function(){return _vm._l((_vm.hindex),function(item,index){return _c('app-user',{key:index,attrs:{"type":"player","item":item,"subtext":item.plays + ' play' + ((item.plays > 1) ? 's' : '')}})})},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }